import React from 'react';
import {connect} from 'react-redux';
import {submit, startSubmit, isSubmitting} from 'redux-form';

import {MODALS} from 'ducks/bookings';

import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';

import {LegacyDocumentEditForm} from './components';

import './styles.css';

class LegacyDocumentEditModal extends React.Component<any> {
  submitForm = () => {
    this.props.submit('legacyDocumentEdit');
  };

  render() {
    const {form: {submitting}} = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.MEDIUM}
        className="LegacyDocumentEditModal">
        <Modal.Header heading="Edit a Document" />
        <Modal.Body>
          <LegacyDocumentEditForm />
        </Modal.Body>
        <Modal.Footer>
          <Button
            blue={!submitting}
            onClick={this.submitForm}
            isLoading={submitting}
            disabled={submitting}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('legacyDocumentEdit')(state)
    }
  };
};

const mapDispatchToProps = {startSubmit, submit};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.LEGACY_DOCUMENT_EDIT)(LegacyDocumentEditModal)
);
